import React from "react";
import "./TravelPlanning.css";
import { Link } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import logo1 from "../../assets/logo1.png";
const TravelPlanning = () => {
  return (
    <div className="travel-page">
      {/* ===== NAVBAR ===== */}
      <div className="navbar">
        <div className="navbar-left">
          <div className="logo-circleeee">
             <img src={logo1} alt="logo-zikrme" className="zikrme-logo-image"/>
          </div>
          <h2>Travel Planning</h2>
        </div>

        <div className="navbar-right">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>

          <div className="search-box">
            <input type="text" placeholder="Search in site" />
            <FiSearch />
          </div>
        </div>
      </div>

      {/* ===== HERO SECTION ===== */}
      <div className="hero-section">
        <h1>
          Personalize Your Travel <br />
          Experience
        </h1>

        <p>
          Fill out the form below to help us create a customized travel plan
          just for you!
        </p>

    <Link to="/form-page"><button className="cta-btn">Get My Custom Plan</button></Link> 
      </div>
    </div>
  );
};

export default TravelPlanning;
